module.exports = __webpack_public_path__ + "static/media/home.89fbec02.svg";